module.exports = __webpack_public_path__ + "img/icon-flag-pt.f0f95b34.svg";